// extracted by mini-css-extract-plugin
export default {"banner":"_3o4NH","stage-notifications":"_-2wLN","stageNotifications":"_-2wLN"};